import React from 'react';

export default class Predictive extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">Predictive Value of 2 Week Outcome</h1>
      <h2>A simple rule of thumb:</h2>
      <blockquote>EARLY IMPROVEMENT (CHANGE OVER A TWO WEEK PERIOD) CAN PREDICT OUTCOME.</blockquote>
      <p>This graph shows data from the "pivotal trials" submitted to the FDA from Bipolar Depression treatment studies.  The red bars show the PPV (positive predictive value) or chance of being a responder after 6-8 weeks of treatment for subjects at least 20% better after 2 weeks of treatment. The purple bars show the NPV (negative predictive value) or chance of not being a responder after 6-8 weeks of treatment for subjects less than 20% better after 2 weeks of treatment.</p>
      <img src="/assets/images/graph.jpeg" />
      <h2 className="title">Measure-Based Guidance:</h2>
      <p>Improvement of at least 20% after the first two weeks of treatment is an encouraging sign.  About 50-60% of patients with this much benefit at two weeks will go on to be treatment responders at 6-8 weeks. The guidance suggests further improvement is likely without change to the current treatment.</p>
      <p>Less than 20% improvement at after two weeks is highly predicative of not responding at 6-8 weeks.  In this case,  the odds favor changing the dose or changing the treatment.</p>
      <p>Ask your clinician about how information like this might apply to your care.</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Predictive.js